import BaseModel from '../model/BaseModel';
import SeatGridService from '../service/seat-grid-service'

export default class Seat extends BaseModel {

    constructor(data) {
        super(data);
        this.Id             = data.Id;
        this.OriginalStatus = data.OriginalStatus;
        this.Position       = data.Position;
        this.Priority       = data.Priority;
        this.SeatStyle      = data.SeatStyle;
        this.SeatsInGroup   = data.SeatsInGroup;
        this.Status         = data.Status;
    }
}




// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Seat.js